<template>
  <div class="content-block">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style lang="scss">
/*------------------------------------*\
  #PRIMARY COLOURS
\*------------------------------------*/
@import "../scss/colors";

/*------------------------------------*\
  #Mixins
\*------------------------------------*/

/*------------------------------------
  #MEDIA SCREENS < 768px (#MOBILE FIRST)
\*------------------------------------*/

.content-block {
  padding: 1rem 0;

  /**
  * Elements
  */
  &__header {
    font-weight: 800;
    // font-size: 2rem;
    margin-bottom: 3rem;
    position: relative;
    color: $dark-grey;

    &::after {
      content: url("../assets/img/_ui/svg/header-hr.svg");
      position: absolute;
      bottom: -1.5rem;
      left: 0rem;
    }

    /*------------------------------------*\
      #MEDIA SCREENS > 576px (TABLETS)
    \*------------------------------------*/
    @media (min-width: 576px) {
    }

    /*------------------------------------*\
      #MEDIA SCREENS > 767px (TABLETS)
    \*------------------------------------*/
    @media (min-width: 767px) {
    }

    /*------------------------------------*\
      #MEDIA SCREENS > 992px
      (LAPTOP, TABLET)
    \*------------------------------------*/
    @media (min-width: 992px) {
    }

    /*------------------------------------*\
      #MEDIA SCREENS > 1200px (DESKTOP)
    \*------------------------------------*/
    @media (min-width: 1200px) {
    }
  }

  &__subheader {
    font-weight: 200;
    margin: 2rem 0 1rem;

    &--blue {
      color: $blue;
    }
  }

  &__list {
    list-style: none;
  }

  &__img {
    display: block;
    margin: 1rem auto;

    /*------------------------------------*\
      #MEDIA SCREENS > 767px (TABLETS)
    \*------------------------------------*/
    @media (min-width: 767px) {
      margin: -1rem auto;

      &--left {
        max-width: 125%;
        height: auto;
        transform: translate(-20%, 0px);
      }

      &--right {
        max-width: 125%;
        height: auto;
        // transform: translate(-25%, 0px);
      }
    }
  }

  &__icon-list {
    text-align: center;
    padding: 0rem 2rem 1rem;
  }

  &__icon {
    display: block;
    margin: 2rem auto;
    max-width: 96px;
  }

  &__document {
    display: block;
    margin: 2rem auto;
    max-width: 300px;
  }

  &__indent {
    margin-left: 2rem;
  }

  &__modal-thumb {
    display: block;
    margin: 2rem auto;
    max-width: 500px;
    background: transparent;
    border: 1px solid #fff;
    position: relative;
    cursor: pointer;
    padding: 0px;

    &::after {
      position: absolute;
      bottom: -20px;
      right: -20px;
      // content: url("../assets/img/_nav/expend-icon-org.png");
    }
  }
}

/*------------------------------------*\
  #MEDIA SCREENS > 767px (TABLETS)
\*------------------------------------*/
@media (min-width: 767px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 992px
  (LAPTOP, TABLET)
\*------------------------------------*/
@media (min-width: 992px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1200px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1200px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1320px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1320px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1600px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1600px) {
}
</style>
